import { CmsMeta } from '../cmsMeta';
import './CmsAtomBackground.css';

export const CmsAtomBackground = ({ image }: { image: string }) => {
	return <div className="cms-atom-background" style={{ backgroundImage: `url(${image})` }}></div>;
};

export const cmsMeta: CmsMeta = {
	description:
		'A background image for the CmsMolecule it sits in. Not a picture in the flow - it fills the block behind the text.',
	example: [
		'CmsAtomBackground',
		{ index: 1, image: 'https://cdn.ondio.com/assets/861d3841028d4a9a861f6fb75948619f.jpg' },
	],
};
